const withItem = (list, item) => list?.includes(item) ? list : [...(list ?? []), item];
/**
 * The player after a step's or chain's upgrades: the card the builder shows
 * for it. Never mutates `player`.
 */
export const applyUpgrades = (player, upgrades) => {
    const next = { ...player };
    for (const upgrade of upgrades) {
        switch (upgrade.type) {
            case "ovr-upgrade":
                next.rating += upgrade.value;
                break;
            case "attribute-upgrade": {
                const attributes = [...(next.attributes ?? [])];
                attributes[upgrade.id] = (attributes[upgrade.id] ?? 0) + upgrade.value;
                next.attributes = attributes;
                break;
            }
            case "skillmoves-upgrade":
                next.skillMoves = (next.skillMoves ?? 0) + upgrade.skillMoves;
                break;
            case "weakfoot-upgrade":
                next.weakFoot = (next.weakFoot ?? 0) + upgrade.weakFoot;
                break;
            case "meta-rating-upgrade":
                next.metaRating = (next.metaRating ?? 0) + upgrade.metaRating.delta;
                break;
            case "play-styles-upgrade":
                if (upgrade.isPlus)
                    next.playStylesPlus = withItem(next.playStylesPlus, upgrade.playStyleId);
                else
                    next.playStyles = withItem(next.playStyles, upgrade.playStyleId);
                break;
            case "position-upgrade":
                next.positions = withItem(next.positions, upgrade.positionId);
                break;
            case "roles-plus-upgrade":
                next.rolesPlus = withItem(next.rolesPlus, upgrade.roleId);
                break;
            case "player-role-upgrade":
                next.playerRoleId = upgrade.playerRoleId;
                break;
        }
    }
    return next;
};
//# sourceMappingURL=upgrades.js.map